import React, { useState, useContext, useEffect } from 'react';
import Logo from './LOGO.svg';
// import Logo from "./Kfintech-logo.svg"
import './Header.css';
// import { Link, Navigate } from "react-router-dom";
// import mobileLightHome from "../../assets/mobileBottomHomeLight.svg";
// import mobileLightMenu from "../../assets/mobileBottomMenuLight.svg";
// import mobileBottomHomeHigh from "../../assets/mobileBottomHomeHigh.svg";

import { useLocation } from 'react-router-dom';
import signOut from '../../assets/sign-out.svg';
// import closeMenu from "../../assets/closeMenu.svg"
// import sideDash from "../../assets/SideNavbar/Dashboard.svg"
// import userProfileDash from "../../assets/SideNavbar/user.svg"
// import DematIconDash from "../../assets/SideNavbar/DematIcon.svg"
// import InVestLogo from "../../assets/SideNavbar/sideNavInvestLogo.svg";

import useAuth from '../../services/authContext';
import { useNavigate } from 'react-router-dom';
const Header = () => {
  const { logout, authed, logoutReferrer, referrer } = useAuth();
  const navigate = useNavigate();
  const [path, setpath] = useState('');
  let location = useLocation(); //to check router path
  // const contextapi = useContext(Context); // to check valid session
  const [pageBool, setpageBool] = useState(false);

  useEffect(() => {
    validateSession();
    setpath(location.pathname);
    console.log(location.pathname);
  }, []);

  const signout = () => {
    logout().then(() => {
      sessionStorage.removeItem('access_token');
      sessionStorage.removeItem('userData');
      navigate('/signIn');
    });

    logoutReferrer().then(() => {
      sessionStorage.removeItem('access_token_refer');
      sessionStorage.removeItem('userData_refer');
      localStorage.clear();
      navigate('/signIn');
    });
  };
  const validateSession = () => {
    if (
      location.pathname == '' ||
      location.pathname == '/' ||
      location.pathname == '/signIn'
    ) {
      setpageBool(false);
    } else {
      setpageBool(true);
    }
  };

  const closeModal = () => {
    // toggleNav()
  };
  return (
    <>
      <div className='container-fluid p-0'>
        <div className='header'>
          <nav className='navbar navbar-expand-md navbar-light'>
            <div className='container-fluid justify-content-center'>
              <a className='navbar-brand' href='https://www.kfintech.com/'>
                <img src={Logo} alt='' className='logo' />{' '}
              </a>
              {/* <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                                <span className="navbar-toggler-icon"></span>
                            </button> */}

              {/* Mobile  */}
              <div className='showMobileHeader'>
                <ul>
                  {(authed || referrer) && (
                    <>
                      <li className='nav-item'>
                        <a className='nav-link' onClick={signout}>
                          <img src={signOut} alt='img' className='signout' />
                        </a>
                      </li>
                    </>
                  )}
                </ul>
              </div>

              {/* end Dialog checknig  */}
              {/* End Mobile  */}
              <div
                className='collapse navbar-collapse justify-content-md-end mobilenav'
                id='navbarNavDropdown'
              >
                <ul className='navbar-nav'>
                  <li className='nav-item'>
                    <a
                      className='nav-link '
                      target='_blank'
                      href='https://mfs.kfintech.com/mfs/'
                    >
                      Mutual Funds
                    </a>
                  </li>

                  <li className='nav-item'>
                    <a
                      className='nav-link '
                      target='_blank'
                      href='https://ris.kfintech.com/'
                    >
                      Corporate Registry
                    </a>
                  </li>

                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      target='_blank'
                      href='https://nps.kfintech.com/'
                    >
                      NPS
                    </a>
                  </li>

                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      target='_blank'
                      href='https://ipo.kfintech.com/'
                    >
                      IPO
                    </a>
                  </li>

                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      target='_blank'
                      href='https://www.kfintech.com/private-wealth-management/'
                    >
                      Private Wealth Management
                    </a>
                  </li>

                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      target='_blank'
                      href='https://www.kfintech.com/alternate-investment-fund/'
                    >
                      Alternatives
                    </a>
                  </li>
                  {/* 
                                    <li className="nav-item">
                                        <a className="nav-link" href="#">
                                            Bonds
                                        </a>
                                    </li>

                                    <li className="nav-item">
                                        <a className="nav-link" href="#">h
                                            Blog
                                        </a>
                                    </li> */}
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      target='_blank'
                      href='https://www.kfintech.com/about-us/'
                    >
                      About Us
                    </a>
                  </li>
                  {(authed || referrer) && (
                    <>
                      <li className='nav-item'>
                        <a className='nav-link' onClick={signout}>
                          <img src={signOut} alt='img' className='signout' />
                        </a>
                      </li>
                    </>
                  )}
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </>
  );
};

export default Header;
